import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { About } from "@/components/About";
import { Designer } from "@/components/Designer";
import { Shop } from "@/components/Shop";
import { Thoughts } from "@/components/Thoughts";
import { Promises } from "@/components/Promises";
import { AnimeFeature } from "@/components/AnimeFeature";
import { Oracle } from "@/components/Oracle";
import { TgcfQuiz } from "@/components/TgcfQuiz";

export default function Home() {
  return (
    <main>
      <Hero />
      <Marquee />
      <About />
      <Oracle />
      <Designer />
      <Shop />
      <Promises />
      <Thoughts />
      <AnimeFeature />
      <TgcfQuiz />
    </main>
  );
}
